import type { BrickInstance } from '../presentation/types';
import { countersFor, seatOf, useScene } from '../scene/SceneContext';
import { ArtImage } from '../art/ArtImage';

/**
 * Read-only help keyed by an observed counter. Artwork never supplies game facts.
 * With `all`, every entry is listed as a static reference (the counter only has to exist and be public).
 */
export function ReferencePanel({inst,seat}:{inst:BrickInstance;seat:string|null}){
  const {table}=useScene();
  const counter=countersFor(inst,table,seatOf(inst,seat,table.selfSeat))[0];
  const entries=(inst.props?.entries as string[]|undefined)??[];
  const images=((inst.props?.images as string[]|undefined)??[]).map(s=>s.split('|'));
  if(!counter||counter.owner!==null)return null;
  if(inst.props?.all===true){
    return <section className="reference-panel is-all" aria-label={(inst.props?.label as string|undefined)??'Rules reference'}>
      {entries.map(raw=>{
        const [value,title,...help]=raw.split('|'), image=images.find(e=>e[0]===value)?.[1];
        return <article key={value} className="reference-entry">
          {image&&<div className="reference-illustration"><ArtImage source={image}/></div>}
          <h2>{title}</h2><p>{help.join('|')}</p>
        </article>;
      })}
    </section>;
  }
  const entry=entries.map(s=>s.split('|')).find(e=>e[0]===String(counter.value));
  if(!entry)return null;
  const image=images.find(e=>e[0]===entry[0])?.[1];
  return <section className="reference-panel" aria-label={entry[1]}>
    {image&&<div className="reference-illustration"><ArtImage source={image}/></div>}
    <h2>{entry[1]}</h2><p>{entry[2]}</p>
  </section>;
}
